import React from "react";
import { MimaText, Modal } from "../../../components";

const ViewMoreParticipantDetails = ({ closeModal, selectedParticipant }) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb={4}>
        Participant Details{" "}
      </MimaText>
      <img
        src={selectedParticipant.profileUrl}
        alt={`${selectedParticipant.firstname} ${selectedParticipant.lastname}`}
        style={{
          width: "10rem",
          height: "10rem",
          borderRadius: "10rem",
        }}
      />
      <MimaText
        mb={2}
      >{`${selectedParticipant.firstname} ${selectedParticipant.lastname}`}</MimaText>
      <div>
        <MimaText mb={2} labelTitle="Competition">
          {selectedParticipant.competition.name}
        </MimaText>
        <MimaText mb={2} labelTitle="Email">
          {selectedParticipant.email}
        </MimaText>
        <MimaText mb={2} labelTitle="Mobile">
          {selectedParticipant.mobile}
        </MimaText>
        <MimaText mb={2} labelTitle="Address">
          {selectedParticipant.address}
        </MimaText>
        <MimaText mb={2} labelTitle="State">
          {selectedParticipant.state}
        </MimaText>
        {selectedParticipant?.instagramHandle && (
          <MimaText mb={2} labelTitle="Instagram Handle">
            {selectedParticipant?.instagramHandle}
          </MimaText>
        )}
        {selectedParticipant?.twitterHandle && (
          <MimaText mb={2} labelTitle="Twitter Handle">
            {selectedParticipant?.twitterHandle}
          </MimaText>
        )}
        {selectedParticipant?.facebookHandle && (
          <MimaText mb={2} labelTitle="Facebook Handle">
            {selectedParticipant?.facebookHandle}
          </MimaText>
        )}
        <MimaText mb={2} labelTitle="Competition Stage">
          {selectedParticipant.competition.stage}
        </MimaText>
        <MimaText mb={2} labelTitle="Vote Count">
          {selectedParticipant.votes}
        </MimaText>
        <MimaText mb={2} labelTitle="Referral Source">
          {selectedParticipant.referralSource}
        </MimaText>
      </div>
      <MimaText variant="bodyBold">Designs</MimaText>
      {selectedParticipant.imageUrls.map((x) => (
        <img
          src={x}
          alt="Design(s)"
          style={{
            width: "20rem",
            height: "20rem",
            padding: "2px",
          }}
        />
      ))}
    </Modal>
  );
};

export default ViewMoreParticipantDetails;
